import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import footerlogo from "../../images/Logo.png";
import appstore from "../../images/appstore.png";
import playstore from "../../images/playstore.png";
import ConsumerRights from "../../images/ConsumerRights.png"
import { SiMinutemailer } from "react-icons/si";
import { TiSocialInstagram } from "react-icons/ti";
import { FaFacebookF, FaTwitter, FaLinkedinIn, FaYoutube } from "react-icons/fa";
import { NavLink } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import { AiFillTwitterCircle } from "react-icons/ai";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import Footerbottomimg1 from "../../images/footerbottem4.png"
import Footerbottomimg2 from "../../images/footerboottom(1).png"
import Footerbottomimg3 from "../../images/footerboottom (2).png"
import Footerbottomimg4 from "../../images/footerboottom(3).png"
const Footer = () => {
    const isBigScreen = useMediaQuery({ query: '(min-width: 991px)' })
    const footerdata = useSelector(state => state.globalslice.data)
        const currentcountry = useSelector((state) => state.globalslice.currentcountry);
    
    return (
        <>
            <div className="footermain primarybackground">
                <Container fluid>
                    <Row>
                        <Col lg={3}>
                            <img src={footerlogo}></img>
                            <div className="footer-discription">UAE and Beyond!
                                Established in 2015, Ourshopee.com has proudly established itself as a prominent and rapidly growing online shopping platform in the region...</div>
                            <div>
                                <img src={ConsumerRights}></img>
                                {
                                    isBigScreen &&
                                    <>
                                        <div className="footer-titles">Connect with us</div>
                                        <div className="d-flex footercontactus">
                                            <input type="text" placeholder="Enter Your Mail" className="header-inputbox"></input>
                                            <div className="header-search secondarybackground"><SiMinutemailer />
                                            </div>
                                        </div>
                                    </>
                                }

                            </div>
                            <div className="footer-titles">Keep in Touch</div>
                            <div className="d-flex">
                                <Link to={currentcountry.fb_link} target="_blank">
                                    <FaFacebookF className="footer-contact-icon" />
                                </Link>
                                <Link to="https://x.com/ourshopee/" target="_blank">
                                    <FaTwitter className="footer-contact-icon" />
                                </Link>
                                <Link to="https://www.linkedin.com/company/ourshopee-com" target="_blank">
                                    <FaLinkedinIn className="footer-contact-icon" />
                                </Link>
                                <Link to={currentcountry.insta_link} target="_blank">
                                    <TiSocialInstagram className="footer-contact-icon" />
                                </Link>
                                <Link to="https://www.youtube.com/channel/UCHxhfnO2bt5DmXf_Ng2_Upw/" target="_blank">
                                    <FaYoutube className="footer-contact-icon" />
                                </Link>

                                {/* <FaTwitter className="footer-contact-icon" />
                                <FaLinkedinIn className="footer-contact-icon" />
                                <TiSocialInstagram className="footer-contact-icon" />
                                <FaYoutube className="footer-contact-icon" /> */}

                            </div>

                        </Col>
                        <Col lg={2} md={4} sm={6} xs={6}>
                            <div className="footerlink-titles">Online Shopping</div>


                            <div className="footer-pages-main">


                                {
                                    footerdata && footerdata.length > 0 && footerdata.slice(0, 10).map(ele => {
                                        return (
                                            <NavLink to={`/categories/${ele.url}`} className="footerlinks text-decoration-none" key={ele.category_id}>{ele.category_name}</NavLink>
                                        )
                                    })
                                }
                            </div>

                        </Col>
                        <Col lg={2} md={4} sm={6} xs={6} className="footer-pages-main">
                            <div className="footerlink-titles">Customer Policies</div>
                            <NavLink
                                to="/aboutus"
                                className="footerlinks textdecoration-none"
                            >
                                About Ourshopee
                            </NavLink>
                            <NavLink
                                to="/contactus"
                                className="footerlinks textdecoration-none"
                            >
                                Contact Us
                            </NavLink>
                            <NavLink
                                to="/blogs"
                                className="footerlinks textdecoration-none"
                            >
                                Our Blog
                            </NavLink>
                            <NavLink
                                to="/terms-and-conditions"
                                className="footerlinks textdecoration-none"
                            >
                                Terms and Conditions
                            </NavLink>
                            <NavLink
                                to="/faqs"
                                className="footerlinks textdecoration-none"
                            >
                                FAQs
                            </NavLink>
                            {/* <div className="footerlinks">Shipping</div>
                            <div className="footerlinks">Cancellation</div>
                            <div className="footerlinks">Warranty & Return Policy</div> */}

                            <NavLink
                                to="/privacy-policy"
                                className="footerlinks textdecoration-none"
                            >
                                Privacy Policy
                            </NavLink>


                        </Col>
                        <Col lg={2} md={4} sm={6} xs={6} className="footer-pages-main">
                            <div className="footerlink-titles">Useful Links</div>
                            {/* <div className="footerlinks">Careers</div> */}
                            <NavLink
                                to="/sitemap"
                                className="footerlinks textdecoration-none"
                            >
                                Site Map
                            </NavLink>
                            <NavLink
                                to="/sell-with-us"
                                className="footerlinks textdecoration-none"
                            >
                                Sell With Us
                            </NavLink>
                            <NavLink
                                to="/affiliate-program"
                                className="footerlinks textdecoration-none"
                            >
                                Affiliate Program
                            </NavLink>

                            {/* <div className="footerlinks">Submit a Review</div> */}
                        </Col>
                        {
                            !isBigScreen &&
                            <Col md={6} sm={6} xs={9}>

                                <>
                                    <div className="footer-titles">Connect with us</div>
                                    <div className="d-flex footercontactus">
                                        <input type="text" placeholder="Enter Your Mail" className="header-inputbox"></input>
                                        <div className="header-search secondarybackground"><SiMinutemailer />
                                        </div>
                                    </div>
                                </>

                            </Col>
                        }

                        <Col lg={3} md={4} sm={6} xs={12} >
                            <div className="">
                                <div className="footerlink-titles">24/7 Customer Support</div>
                                <div className="footer-discription">
                                    Ourshopee support team is hard working 24/7 for our customers. We give high priority to troubleshoot and sort out all the complaints and issues of our customers.
                                </div>
                                <div className="footerlink-titles">We're always here to help you</div>
                                <div className="footer-discription">
                                    Reach out to us through any of these support channels
                                </div>
                                <div className="footercontact-titles">Hotline :<span className="footercontact">{currentcountry?.helpline_numbers?.hotline}</span></div>
                                <div className="footercontact-titles">WhatsApp :<span className="footercontact">{currentcountry?.helpline_numbers?.whatsapp}</span></div>
                                <div className="footercontact-titles">E-mail :<span className="footercontact">support@ourshopee.com</span></div>
                            </div>
                            <div className="footer-applinks-main">
                                <div className="footerlink-titles mobilegrtapptitle mobileapplinks">Get App</div>
                                <div className="mobileapplinks">
                                    <Link to="https://apps.apple.com/us/app/ourshopee-online-shopping/id1226954989" target="_blank">
                                        <img src={appstore} className="pb-2 applinks "></img>
                                    </Link>
                                </div>
                                <div className="mobileapplinks">
                                    <Link to="https://play.google.com/store/apps/details?id=www.ourshopee.com" target="_blank">
                                        <img src={playstore} className="pb-2 applinks"></img>
                                    </Link>
                                </div>
                            </div>
                        </Col>

                    </Row>
                </Container>

            </div >
            <div className="footercopyrights">
                <Container fluid>
                    <Row >
                    {
                            !isBigScreen &&
                            <Col lg={6} md={6} sm={12}>
                            <div className="">
                                <img className="pe-2" src={Footerbottomimg1}></img>
                                <img  className="pe-2" src={Footerbottomimg2}></img>
                                <img  className="pe-2" src={Footerbottomimg3}></img>
                                <img  className="pe-2" src={Footerbottomimg4}></img>
                            </div>
                        </Col>
                        }
                        <Col lg={6} md={6} sm={12}>
                            <div className="copyright-contant">
                                © Copyright 2025 www.ourshopee.com. All rights reserved.
                            </div>
                        </Col>
                        {
                            isBigScreen &&
                            <Col lg={6} md={6} sm={12}>
                            <div className="footerbottom">
                                <img className="pe-2" src={Footerbottomimg1}></img>
                                <img  className="pe-2" src={Footerbottomimg2}></img>
                                <img  className="pe-2" src={Footerbottomimg3}></img>
                                <img  className="pe-2" src={Footerbottomimg4}></img>
                            </div>
                        </Col>
                        }
                     

                    </Row>
                </Container>
            </div>


        </>

    )
}
export default Footer;